import { IconProps } from '../icon-props-interface';
import '../icons.scss';

export const IconDuplicate = ({ color = 'var(--color-accent-1)' }: IconProps): JSX.Element => (
    <div className="icon-block">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
            <path d="M5 5H2C1.44772 5 1 5.44772 1 6V16C1 16.5523 1.44772 17 2 17H12C12.5523 17 13 16.5523 13 16V13.4" stroke={color}/>
            <rect x="4.70703" y="1" width="12" height="12" rx="1" stroke={color}/>
            <path d="M9 7H13" stroke={color} strokeLinecap="round"/>
            <path d="M11 9L11 5" stroke={color} strokeLinecap="round"/>
        </svg>
    </div>
);

export default IconDuplicate;
